import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import PlanList from "../../Components/PlanList";
import MinPlanPrice from "../../Components/MinPlanPrice";
import sal from "sal.js";
import AllFeatures from "../../Components/AllFeatures";
import { Helmet } from "@dr.pogodin/react-helmet";
import { ScrollToPlans } from "../../utils/ScrollToPlan";
import CouponScrollBar from "../../Components/CouponScrollBar";

export default function LinuxResellerHosting() {
  const [applyPaddingClass, setApplyPaddingClass] = useState(false);
  useEffect(() => {
    document.title = "Reseller Hosting Plans with cPanel, WHM & SSD Storage";
      sal();
  }, []);

  const handlePlanClick = () => {
      ScrollToPlans(".price-plan-section");
      };

  return (
    <>
    <Helmet>
        <title>Reseller Hosting Plans with cPanel, WHM & SSD Storage</title>
        <meta name="description" content="Start your hosting business with powerful reseller hosting. Get cPanel & WHM, SSD storage, free SSL, unlimited bandwidth, and scalable plans." />
        <meta name="keywords" content="Linux Reseller, Linux Reseller Web Hosting, Best Linux Reseller Hosting, Hosting Reseller Linux, Reseller Linux, Unlimited Linux Reseller Hosting, Linux-Reseller-Hosting" />
        <meta property="og:url" content={`${import.meta.env.VITE_FRONTEND_URL}/linux-reseller-hosting`} />
        <link rel="canonical" href={`${import.meta.env.VITE_FRONTEND_WWW_URL}/linux-reseller-hosting`} />
        <meta property="og:title" content="Budget-Friendly Linux Reseller Hosting for Your Business" />
        <meta property="og:description" content="Begin your own hosting business with Linux reseller hosting. Enjoy high performance & constant support, helping you to tailor services and grow seamlessly." />
    </Helmet>
      <section className="banner-bg bg-dark linux-reseller-banner">
          <div className="container">
            <div className="row align-items-center">
                <div className="col-lg-7 col-xl-6">
                  <span className="fs-18 fw-semibold text-primary mb-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Scalable and Stable</span>
                  <h1 className="text-white mb-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Flip the Script: Client to Linux Reseller Hosting Provider</h1>
                  <p className="mb-8 text-white max-text-72 text-opacity-75 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Why settle for general hosting when you can create your hosting brand? Linux Reseller Hosting enables you to guide others in going digital-no tech stress, just continuous support.</p>
                  <div className="d-flex align-items-center gap-5 flex-wrap sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                      <button onClick={handlePlanClick} className="btn btn-primary btn-arrow btn-arrow btn-arrow-md btn-lg fs-14 fw-medium rounded btn-height">
                        <span className="btn-arrow__text">Get Started
                          <span className="btn-arrow__icon">
                            <i className="fa-solid fa-arrow-right"></i>
                          </span>
                        </span>
                      </button>
                      <MinPlanPrice category="linux-reseller-hosting" />
                  </div>
                 <span className="d-block fs-14 text-white text-opacity-75 mt-2 sal-animate" data-sal="slide-up" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">Get 100% Refund Within 30 Days* <sup><small className="text-opacity-50 tnc-text">T&Cs</small></sup></span>
                </div>
                <div className="col-lg-5 col-xl-6 text-lg-end ipad-mt">
                  <img alt="image" className="img-fluid sal-animate full-width-img" data-sal="fade" data-sal-duration="1500" data-sal-delay="300" data-sal-easing="ease-in-out-sine" src="/images/flip-the-script-from.webp" />
                </div>
            </div>
          </div>
      </section>

      <div className="container pt-100 pb-100">
        <div className="row">
            <div className="col-12">
                <div className="bg-dark pt-80 pb-80 px-5 px-md-8 px-xl-12 rounded-4 position-relative z-1 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <div className="row g-4 align-items-center">
                      <div className="col-lg-6">
                          <div className="row g-4 g-xl-0 feature-card">
                            <div className="col-xxl-8 feature-card__list m-auto">
                              <div className="feature-card__is rounded-3">
                                <div className="mb-4">
                                    <img src="images/from-zero-to-hero.webp" alt="image" className="img-fluid" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6 col-xl-6">
                            <h2 className="text-white">
                                Start Your Journey with Reseller Plans
                            </h2>
                            <p className="mb-8 text-white text-opacity-75">
                                Why create someone else’s brand when you can grow your own? Our best Linux reseller hosting give you the power to build, sell, and handle all solutions customized as per your audience. 
                            </p>
                            <Link to="tel:7737300013" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded me-sm-4 m-auto btn-height">
                              <span className="d-inline-block me-1 flex-shrink-0">
                                <i className="las la-comments"></i>
                              </span>
                              <span className="btn-arrow__text">+91-7737300013
                                <span className="btn-arrow__icon">
                                  <i className="fa-solid fa-arrow-right"></i>
                                </span>
                              </span>
                            </Link>
                            <Link to="#" className="btn btn-primary btn-arrow btn-lg fs-14 fw-medium rounded me-sm-2 m-auto mt-sm-0 mt-4 open-live-chat btn-height">
                              <span className="d-inline-block me-1 flex-shrink-0">
                                <i className="las la-comments"></i>
                              </span>
                              <span className="btn-arrow__text">Talk to an Expert
                                <span className="btn-arrow__icon">
                                  <i className="fa-solid fa-arrow-right"></i>
                                </span>
                              </span>
                            </Link>
                        </div>
                    </div>
                    <img src="images/vps-feature-shape.png" alt="image" className="img-fluid d-none d-xl-block position-absolute left-0 top-0 z-n1" />
                </div>
            </div>
        </div>
      </div>

      <div className="feedback-section-1 pt-40 pb-100">
        <div className="pb-60">
          <div className="container">
              <div className="row g-4 align-items-center justify-content-xl-between">
                <div className="col-lg-6 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                    <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded">
                      <span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>
                      Linux Reseller
                    </small>
                    <h2 className="mb-4">From Dreamer to Provider: Check Out Our Reseller Plans</h2>
                    <p className="max-text-56 mb-0 fw-semibold">Experience unmatched reliability with our Linux hosting built for speed, security, and scalability. Enjoy effortless performance, 24/7 expert support, and flawless uptime to keep your website unstoppable.</p>
                </div>
                <div className="col-lg-6 col-xl-5 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                    <div className="card">
                      <div className="card-body cloud-hosting-vid-card">
                                <div className="features-video position-relative z-1">
                                    <img src="/images/infi-common-video-yt-thumb.jpg" alt="image" className="img-fluid w-100"/>
                                    <Link to="https://youtu.be/x10KM9gI110?si=kVgGnbSAsh-zfKn7" target="_blank" className="btn gradient-bg w-15 h-15 d-grid place-content-center rounded-circle position-absolute top-50 start-50 translate-middle fs-24 text-white popup-init">
                                        <i className="fa-solid fa-play"></i>
                                    </Link>
                                </div>
                            </div>
                    </div>
                </div>
              </div>
          </div>
        </div>
        <div className="container">
          <div className="row g-4">
            <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
              <div className="card border-0 shadow-sm rounded-4 h-100">
                  <div className="card-body p-md-6 p-xl-8">
                    <div className="mb-8"><img alt="image" className="img-fluid" src="/images/you-manage-clients.webp" /></div>
                    <h6 className="mb-4">You Manage Clients, We Manage Support</h6>
                    <p className="mb-0">Focus on your business success-we’ll proactively manage all technical issues before they escalate. With 24/7 support for Linux Reseller Hosting, we’re your true supporter, keeping everything smooth.</p>
                  </div>
              </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                      <div className="mb-8"><img alt="image" className="img-fluid" src="/images/built-for-high-performance.webp" /></div>
                      <h6 className="mb-4">Built for High-Performance, Best for Resellers</h6>
                      <p className="mb-0">Worried about unhappy customers & bad performance? Our Linux Reseller Hosting is built for high performance, giving the speed your business wants. Let your hosting do all the traffic lifting-while you stand out among others.</p>
                    </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                      <div className="mb-8"><img alt="image" className="img-fluid" src="/images/smooth-collaboration.webp" /></div>
                      <h6 className="mb-4">Smooth Collaboration, Streamlined Hosting</h6>
                      <p className="mb-0">Work cleverly in the case of shared access for your clients, billing, and processes. With our reseller hosting plans, collaboration becomes smooth, so you can focus on your growth instead of managing the chaos.</p>
                    </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                      <div className="mb-8"><img alt="image" className="img-fluid" src="/images/intuitive-admin-panel.webp" /></div>
                      <h6 className="mb-4">Intuitive Admin Panel, Effortless Hosting</h6>
                      <p className="mb-0">Our user-friendly admin panel is engineered for genuine people, with no tech expertise, no complicated learning curves. Just full control at your fingertips, so you can handle your hosting empire without dripping a sweat.</p>
                    </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="400" data-sal-easing="ease-in-out-sine">
                <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                      <div className="mb-8"><img alt="image" className="img-fluid" src="/images/no-limits-just.webp" /></div>
                      <h6 className="mb-4">No Limits. Just Reliable & Permanent Clients.</h6>
                      <p className="mb-0">With our Linux Reseller Hosting, there are no specific boundaries set-just limitless opportunities. Experience freedom with the rock-solid power and unlimited assets to configure web reseller hosting your way.</p>
                    </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-4 sal-animate" data-sal="slide-up" data-sal-duration="1000" data-sal-delay="500" data-sal-easing="ease-in-out-sine">
                <div className="card border-0 shadow-sm rounded-4 h-100">
                    <div className="card-body p-md-6 p-xl-8">
                      <div className="mb-8"><img alt="image" className="img-fluid" src="/images/security-that-always.webp" /></div>
                      <h6 className="mb-4">Security That’s Always Stands For You</h6>
                      <p className="mb-0">Sleep comfortably knowing your Linux Reseller Hosting is secure with our built-in security, on-time backups, and real-time server monitoring. We take care of all issues-so you can center on your business success without stress.</p>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      <section className="price-plan-section pt-100 pb-100 position-relative">
        <CouponScrollBar setPaddingClass={setApplyPaddingClass} />
        <div className={`pb-40 ${applyPaddingClass ? "plan-extra-top-padding" : ""}`}>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="text-center">
                            <span className="section-title-dark style-bg fadeInUp">Our Plans</span>
                            <h2 className="theme-title-text-white" data-sal="slide-up" data-sal-duration="500" data-sal-delay="200" data-sal-easing="ease-in-out-sine"> Your Brand. Your Plans.</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <PlanList category={'linux-reseller-hosting'}/>
      </section>

      <section className="pt-100 pb-100 position-relative">
        <div className="container">
            <div className="row g-4">
                <div className="col-lg-5 mb-lg-0 mb-5">
                    <div className="position-sticky start-0 top-20">
                      <small className="d-inline-block mb-2 fw-bold bg-primary-subtle text-primary-emphasis border border-primary-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-primary rounded-circle me-1"></span>For Hustlers and Idealists</small>
                        <h2 className="max-text-20 ff-sg mb-4">Why Infinitive Host’s Web Reseller Hosting Built for Hustlers?</h2>
                        <p className="max-text-44 mb-8">Because our Linux Web Reseller Hosting mixes performance and entrepreneurial freedom-engineered for those who dream and engineered for risk-takers.</p>
                      <button onClick={handlePlanClick} className="btn btn-lg btn-light border-0 fw-semibold bg-yellow-custom rounded-pill d-inline-flex align-items-center gap-2">
                        Discover Now <span className="fs-18"><i className="fa-solid fa-arrow-right"></i></span>
                      </button>
                    </div>
                </div>
                <div className="col-lg-7">
                    <div className="row g-4">
                        <div className="col-md-6">
                            <div className="blog_11_item bg-blue p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/high-uptime-growth.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">High Uptime & Growth</h3>
                                <p className="dark-card-p-color">Downtime decreases site traffic-and we know how that really hurts. Our best Linux reseller hosting is engineered for high uptime. With 24/7 support, we make sure that your clients stay available.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-dark-11 p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/migration-without-downtime.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Migration Without Downtime</h3>

                                <p className="dark-card-p-color">Switching hosts is not easy at all. With the help of our free migration, you won’t have to lift a finger. We’ll carry over your data safely-so you can emphasize success, not unexpected delays.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-dark-11 p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/full-access-happy.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Full Access = Happy Clients</h3>
                                <p className="dark-card-p-color">Offers your clients a user-friendly experience. With cPanel crafted into our reseller hosting & emails becomes a breeze. Stay ahead without the stress-check resources & manage accounts.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-blue p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/one-plan-unlimited.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">One plan, Unlimited Sites</h3>
                                <p className="dark-card-p-color">With the help of our Linux Reseller Web Hosting, you're not just restricted to only one site. Easily manage numerous domains, subdomains, and add-ons under every cPanel account-no limit.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-blue p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/your-location.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Your Location, Your Choice</h3>
                                <p className="dark-card-p-color">Host nearer to your target audience with our Linux Reseller Hosting plans-select from the US, UK, Australia, Asia, and Europe data centers for improved speed, high uptime, and happier clients.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-dark-11 p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/one-tap-installation.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Single-Tap Installation</h3>
                                <p className="dark-card-p-color">With the help of our Linux Reseller Web Hosting, install WordPress, Joomla, and Drupal and 400+ programs in just one click. Effortless setups that always keep you and your clients moving ahead.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-dark-11 p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/protect-sites-from.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Protect Sites From Malware</h3>
                                <p className="dark-card-p-color">Your site’s security is our main priority. With our reseller hosting solutions, you get in-built malware protection that works in the background-scanning every day and resolving issues quickly.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-blue p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/fast-ssd-fast growth.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Fast SSD. Fast Growth.</h3>
                                <p className="dark-card-p-color">Boost your hosting speed with 100% SSD storage. Our Best Linux Reseller Hosting guarantees quicker loading times and overjoyed customers-everyone powered by high-speed SSDs.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-blue p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/managed-to-perfection.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Managed to Perfection</h3>
                                <p className="dark-card-p-color">Experience hands-free hosting with the help of our fully managed Linux reseller solutions. We simply take care of all the information so you can flawlessly grow, scale, and serve your customers.</p>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="blog_11_item bg-dark-11 p-6 rounded-3 border border-white border-opacity-10 h-100">
                                <div className="overflow-hidden rounded-4 mb-4">
                                    <img src="images/name-It-your-way.webp" alt="Image" className="img-fluid" />
                                </div>
                                    <h3 className="text-white fs-20 mb-6">Choose Name On Your Own</h3>
                                <p className="dark-card-p-color">Stand out among all competitors with private name servers under your brand name. Provide an expert touch along with our reseller hosting in India-engineered for all resellers who mean business.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>

      <section className="bg-dark pt-100 pb-100 position-relative allfeatures-wrapper">
        <img src="images/service_16_shape_2.png" alt="Image" className="img-fluid position-absolute start-0 bottom-0 pattern-bg-img"></img>
        <div className="pb-40">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-md-10 col-lg-9 col-xl-7">
                        <div className="text-center sal-animate" data-sal="slide-up" data-sal-duration="500" data-sal-delay="300" data-sal-easing="ease-in-out-sine">
                          <span className="section-title-dark style-bg fadeInUp">Features</span>
                            <h2 className="text-white">
                                Complete Hosting Solutions
                            </h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AllFeatures />
    </section>

    <section className="pt-100 pb-100">
      <div className="">
        <div className="container">
          <div className="card cta-wrapper-one domain-container-inner rounded-3">
            <div className="card-body p-md-6 p-xl-10">
              <div className="row g-4 align-items-center">
                  <div className="col-md-6">
                      <img src="images/swift-free-migration.webp" alt="image" className="img-fluid" />
                  </div>
                <div className="col-md-6">
                  <small className="d-inline-block mb-2 fw-bold bg-success-subtle text-success-emphasis border border-success-subtle px-3 py-1 rounded"><span className="d-inline-block w-2 h-2 bg-success rounded-circle me-1"></span>Migration</small>
                  <h5 className="mt-3 mb-4">
                      Swift & Free Migration, On Us
                  </h5>
                  <p className="mb-8">
                      Switching to a new host shouldn't feel like a struggle. That’s why we provide free site migration with each Linux Reseller Hosting solution. Our experts manage everything just for you-securely and flawlessly-so you don’t lose sleep (or data).
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    </>
  );
}
